import type { DueSoonWindow } from '@app-types';

const SUBMISSION_ASSESSMENT_STATUSES = 'Pending Evidence,Evidence Past Due,Escalated';
const ESCALATED_STATUSES = 'Evidence Past Due,Escalated';
const MIN_ESCALATED_LEVEL = '2';

function route(path: string, params: Record<string, string>): string {
  return `${path}?${new URLSearchParams(params)}`;
}

const assessments = (params: Record<string, string>) => route('/assessments', { scope: 'contract', ...params });
const evidence = (params: Record<string, string>) => route('/evidence', { status: 'action_required', ...params });

/** Where each Assessment metric card of the Contract Role launch page navigates. */
export const CONTRACT_ROLE_METRIC_ROUTES = {
  assessmentsPendingEvidence: assessments({ status: 'Pending Evidence' }),
  assessmentsPastDue: assessments({ status: 'Evidence Past Due' }),
  assessmentsEscalated: assessments({ status: ESCALATED_STATUSES, min_escalation_level: MIN_ESCALATED_LEVEL })
} as const;

/**
 * Where each Evidence quick action navigates. Every target lists exactly the items its tile counts,
 * so the Due Today/Tomorrow dates come from the endpoint's own window and are never recomputed in the browser.
 */
export function buildContractRoleQuickActionRoutes(window: DueSoonWindow) {
  return {
    evidencePendingSubmission: evidence({ assessment_status: SUBMISSION_ASSESSMENT_STATUSES }),
    evidenceDueSoon: evidence({
      assessment_status: 'Pending Evidence',
      evidence_due_from: window.due_soon_from,
      evidence_due_to: window.due_soon_to
    }),
    evidencePastDue: evidence({ assessment_status: 'Evidence Past Due' }),
    evidenceEscalated: evidence({ assessment_status: ESCALATED_STATUSES, min_escalation_level: MIN_ESCALATED_LEVEL })
  };
}
